<template>
    <v-overlay :value="dialog">
        <v-dialog
            v-model="dialog"
            persistent
            overlay-color="#514585"
            overlay-opacity="0.98"
            content-class="d-flex justify-center align-center overflow-hidden"
        >
            <v-img
                :src="require('@/assets/img/icons/check-stroke.png')"
                class="dialog-icon"
                height="80"
                width="80"
                />
            <v-card
                dark
                class="d-flex flex-column justify-center align-center border-radius-1"
            >
                <div class="d-flex flex-column justify-center align-center position-relative">
                    <div class="px-4 pt-5 pb-2 mx-5 d-flex justify-center align-center flex-column">
                        <div class="mt-4">
                            <span class="text-h6 font-weight-bolder line-height-120">
                                {{ title }}
                            </span>
                        </div>
                    </div>
                    <v-row>
                        <v-col class="pa-0">
                            <v-chip
                                label
                                dark
                                small
                                color="#514585"
                                class="text-transform-uppercase"
                                >
                                {{ $t('challenge.correctAnswers') }}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <div class="px-5 mx-5">
                        <div class="d-flex justify-center flex-row align-center pa-5">
                            <SuperStar :content="count_corrects" />
                        </div>
                    </div>
                    <v-row class="">
                        <v-col cols="10" offset="1">
                            <p class="mb-0">{{ result_msg }}</p>
                        </v-col>
                    </v-row>
                    <v-card-actions
                        class="d-flex justify-center align-center mb-5 w-95"
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            data-cy="resultMsgModal-finish-by-correct-answers-button"
                            color="white"
                            large
                            block
                            class="text--primary text-transform-none border-radius-1 font-weight-bolder"
                            @click="collectPrize"
                            :disabled="isCollectingPrize"
                            id="collect-prize-button"
                            v-if="count_corrects >= 4 && !finish && showCollectPrizeButton"
                        >
                            {{ $t('challenge.collect_prize') }}
                        </v-btn>
                    <v-row class="w-100">
                        <v-col cols="">
                            <v-btn
                                data-cy="resultMsgModal-try-again-button"
                                color="white"
                                large
                                block
                                class="px-16 py-5 white--text border-radius-1 text-transform-none font-weight-bolder"
                                outlined
                                @click="goOut"
                                v-if="count_corrects < 4 && !finish"
                            >
                                {{ $t('bookReading.go_out') }}
                            </v-btn>
                        </v-col>
                        <v-col cols="">
                            <v-btn
                                data-cy="resultMsgModal-try-again-button"
                                color="white"
                                large
                                block
                                class="text--primary text-transform-none border-radius-1 font-weight-bolder"
                                @click="tryAgain"
                                v-if="count_corrects < 4 && !finish"
                            >
                                {{ $t('bookReading.try_again') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                        <v-btn
                            data-cy="resultMsgModal-finish-button"
                            color="white"
                            large
                            block
                            class="text--primary text-transform-none border-radius-1 font-weight-bolder"
                            @click="finishAction"
                            v-if="finish"
                        >
                            {{ $t('initialTour.finish') }}
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </v-overlay>
</template>
<script>
/* eslint-disable global-require */

import SuperStar from '@/components/core/SuperStar.vue'
import {confetti} from 'dom-confetti'
import {CONFETTI_SETUP} from '../../../../../constants/DefaultConstants'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        count_corrects: { type: [String, Number], default: 0 },
        finish: { type: Boolean, default: false },
    },
    components: {
        SuperStar,
    },
    data() {
        return {
            varitaImg: require('@/assets/img/icons/beecoins-1.svg'),
            absolute: true,
            isCollectingPrize: false,
            // Anti-automation properties
            prizeAvailableTime: null,  // Timestamp cuando el premio estará disponible
            currentTime: Date.now(),   // Para reactividad de computed properties
        }
    },
    methods: {
        timer(ms=1000) {
            return new Promise(res => setTimeout(res, ms));
        },
        async collectPrize() {
            if (this.isCollectingPrize) {
                // La función ya está en progreso, no hacer nada
                return;
            }
            // Marcar como en progreso
            this.isCollectingPrize = true;
            this.celebrateSuccess(document.querySelector('#collect-prize-button'));
            await this.timer(2 * 1000);
            this.$emit('collect-prize');
            // Restablecer el estado después de la finalización
            this.isCollectingPrize = false;
            // Anti-automation: Reset para siguiente uso
            this.prizeAvailableTime = null;
        },
        tryAgain() {
            this.$emit('try-again')
        },
        goOut() {
            this.$router.go(0)
        },
        finishAction() {
            this.$emit('finish-action')
        },
        celebrateSuccess(el = null){
            if(el) confetti(el, CONFETTI_SETUP)
        },
    },
    computed: {
        result_msg() {
            const dictionary = {
                '4': this.$t('challenge.result_msg_4'),
                '3': this.$t('challenge.result_msg_3'),
                '2': this.$t('challenge.result_msg_2'),
                '1': this.$t('challenge.result_msg_1'),
                '0': this.$t('challenge.result_msg_0'),
            }
            const answerCounter = String(this.count_corrects)
            return dictionary[answerCounter] || dictionary['0']
        },
        title() {
            const dictionary = {
                '4': this.$t('challenge.title_msg_4'),
                '3': this.$t('challenge.title_msg_3'),
                '2': this.$t('challenge.title_msg_2'),
                '1': this.$t('challenge.title_msg_1'),
                '0': this.$t('challenge.title_msg_0'),
            }
            const answerCounter = String(this.count_corrects)
            return dictionary[answerCounter] || dictionary['0']
        },
        isChallengePerfect() {
            return ['4', 4].includes(this.count_corrects)
        },
        // Anti-automation: Control button visibility based on timing
        showCollectPrizeButton() {
            if (this.isCollectingPrize) return false;
            if (!this.prizeAvailableTime) return false; // No mostrar hasta que se establezca el tiempo
            return this.currentTime >= this.prizeAvailableTime;
        }
    },
    // Anti-automation: Set prize available time when dialog opens
    watch: {
        dialog(newVal) {
            if (newVal && this.count_corrects >= 4) {
                this.prizeAvailableTime = Date.now() + 2000;
            }
        }
    },
    mounted() {
        // Anti-automation: Update currentTime for reactive computed properties
        const vm = this;
        setInterval(() => {
            vm.currentTime = Date.now();
        }, 100);
    },
}
</script>
<style>
.bee-img {
    width: 15vh;
    text-align: left;
    top: 2.5vh;
    left: 2.5vh;
    line-height: 1.5vh;
}
.bee-img span {
    font-size: 12px !important;
    font-weight: 400;
    letter-spacing: 1px !important;
}
.bee-img img {
    height: 5vh;
}
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.result-content {
    width: 35%;
    box-sizing: border-box;
    border: 2px solid #4bada1;
    background: radial-gradient(circle, #f4f9f9 0%, #ceecea 100%);
    box-shadow: -7px 6px 12px 5px rgba(0, 0, 0, 0.07);
}

.items-unset {
    align-items: unset !important;
}

.bright-points {
    align-items: center;
    color: #816ad6;
}

.bright-beecoin {
    align-items: center;
    color: darkgoldenrod;
}

.form-title {
    color: white;
    font-size: 2.5vw;
}

.form-text {
    font-size: 1.2vw;
    color: white;
}

.beecoin-top-1 {
    z-index: 1;
    position: relative;
    bottom: 11vh;
    left: 5vw;
}

.beecoin-top-2 {
    transform: rotate(15deg);
    position: relative;
    bottom: 13vh;
    left: 1vw;
}

.text-beecoin {
    font-size: 1vw;
}

.button-text {
    text-transform: none;
    font-size: 1vw;
}
.bee-icon-size {
    width: 16.5vh;
}
.bee-icon-size-2 {
    width: 17.5vh;
}
.z-text {
    z-index: 10;
}
.result-msg-content {
    background-color: #d5efee;
    font-weight: bold !important;
}
</style>
